export class MapForm {
  Heading: string;
  Name: string;
  Description: string;
  UpdatedOn: Date;
}
